import { render, staticRenderFns } from "./InvoiceAlbum.vue?vue&type=template&id=def0034e&scoped=true"
import script from "./InvoiceAlbum.vue?vue&type=script&lang=js"
export * from "./InvoiceAlbum.vue?vue&type=script&lang=js"
import style0 from "./InvoiceAlbum.vue?vue&type=style&index=0&id=def0034e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def0034e",
  null
  
)

export default component.exports